import React from "react";

import { useLoggedInUser } from "components/LoggedInUserProvider";
import RacingSecretaryHorseList from "./RacingSecretary";

const PreferredConditionPage = () => {
  const { currentUser } = useLoggedInUser();

  if (currentUser.isRacingOfficial || currentUser.isAdmin) {
    return <RacingSecretaryHorseList />;
  }

  return <></>;
};

export default PreferredConditionPage;
